import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";

const AIEnterprise = () => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const navigateUrl = () => {
        window.location.href = "https://t0.projecte8.com/join-waitlist";
    }

    const navigateUrlSales = () => {
        navigate("/contact/sales")
    }

    return (
        <div className="section_container">
            <div>

                <h3 className="section_kicker_last">{t.website.ai_enterprise.kicker}</h3>
                <h3 className="section_title_last">{t.website.ai_enterprise.title}</h3>
                <p className="section_subtitle_last">{t.website.ai_enterprise.subtitle}</p>
                {/* <button className="start_now_btn fade-in" onClick={() => navigate("/register")}>{t.website.navbar.start_now}</button> */}
                <button className="start_now_btn" onClick={navigateUrlSales}>
                    {t.website.sales.contact_btn}
                </button>
            </div>
        </div>
    );
};

export default AIEnterprise;
